import { SpaceVertical } from "../../../common/utils/spacing";
import "./realisation.css";
import frame1 from "../../../assets/realisation/frame1.png";
import frame2 from "../../../assets/realisation/capture-portfolio.png";
import frame3 from "../../../assets/realisation/frame3.png";
import frame4 from "../../../assets/realisation/frame4.png";
import { Button } from "antd";

export const RealisationMobile = () => {
  return (
    <div className="m-realisation m-page">
      <h1 className="title">MES REALISATION </h1>
      <SpaceVertical size={25} />

      <div className="m-realisation-content">
        <OneRealisation
          title="CLONE INSTAGRAM"
          tech="Figma"
          date="2020"
          text="Reproduction de la partie 'UI UX' de l'apllication mobile Instagram en utilisant comme technologie Figma"
          image={frame1}
          link={`https://www.figma.com/proto/ttikA7ZMIh6WXdV6eYDgt9/Instagram?node-id=51%3A99&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=51%3A99&hide-ui=1`}
        />
        <OneRealisation
          title="MON PORTFOLIO"
          tech="React JS"
          date="2021"
          text="Développement de mon portfolio avec React Js"
          image={frame2}
          link="https://portfolio-hali.web.app/"
        />
        <OneRealisation
          title="Clone site Meta de Facebook"
          tech="React Js"
          date="2022"
          text="Clonage du site meta de facebook en utilisant comme technologie React Js"
          image={frame3}
          link="https://meta-site-28b7b.web.app/"
        />
        <OneRealisation
          title="FIGMA"
          tech="Figma"
          date="2022"
          text="Clonage du UI UX Design du site meta de facebook avec Figma"
          image={frame4}
          link={`https://www.figma.com/proto/8NqCF4kRbxxlQwbkOoDGdc/facebook-meta?node-id=1%3A2&scaling=min-zoom&page-id=0%3A1&starting-point-node-id=98%3A4&hide-ui=1`}
        />
      </div>
    </div>
  );
};

const OneRealisation = ({ title, tech, date, text, image, link }) => {
  return (
    <a href={link} className="m-one-realisation">
      <div
        className="img"
        style={{
          backgroundImage: `url(${image})`,
        }}
      ></div>

      <SpaceVertical size={10} />
      <h3>{title}</h3>
      <SpaceVertical size={1} />

      <span className="tech-date">{`${tech} - ${date}`}</span>

      <SpaceVertical size={1} />
      <p>{text}</p>
      <SpaceVertical size={10} />

      <Button type="primary" style={{color:'white'}}>
        En savoir plus
      </Button>
    </a>
  );
};
